// Logo
export const logoBlack = '/images/site_logo/logo_black.png';

// Service Icons (using existing industry SVGs as placeholders)
export const aiSoftwareIcon = '/images/icons/icon_code.svg';
export const marketingAdvertisingIcon = '/images/icons/marketing-industry.svg';
export const technicalSupportIcon = '/images/icons/icon_headphone.svg';
export const teamStaffingIcon = '/images/icons/icon_users.svg';

// Industry Icons
export const aiIndustryIcon = '/images/icons/ai-industry.svg';
export const webDevIndustryIcon = '/images/icons/web-dev-industry.svg';
export const startupIndustryIcon = '/images/icons/startup-industry.svg';
export const educationIndustryIcon = '/images/icons/education-industry.svg';
export const marketingIndustryIcon = '/images/icons/marketing-industry.svg';
export const healthcareIndustryIcon = '/images/icons/healthcare-industry.svg';
export const realEstateIndustryIcon = '/images/icons/real-estate-industry.svg';
export const ecommerceIndustryIcon = '/images/icons/ecommerce-industry.svg';
